<span
  class="s-pt-1 s-pb-1 s-ps-2 s-pe-2 rounded font-weight-bold s-x-small-bold"
  [ngClass]="{ yes: value(), no: !value() }"
>
  {{ (value() ? 'COMMON.YES' : 'COMMON.NO') | translate }}
</span>
